import { requestApi } from 'api/api'
import { EarnAssetDetailsResponse, EarnDashboardResponse } from 'types/earn'
import { LedgerWalletTransactionsResponse } from 'types/ledger/ledgerWalletTransactions'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'

export const getEarnDashboard = async (): Promise<EarnDashboardResponse> => {
  return requestApi({
    url: '/earn/dashboard',
    baseUrl: process.env.API_URL,
    method: 'GET',
  })
}

export const getEarnAssetDetails = async (
  portfolioId: string
): Promise<EarnAssetDetailsResponse> => {
  return requestApi({
    url: `/earn/asset/${portfolioId}`,
    baseUrl: process.env.API_URL,
    method: 'GET',
  })
}

export const getEarnAssetTransactions = async (
  portfolioId: string,
  {
    page = API_PAGINATION_OFFSET,
    size = API_PAGINATION_LIMIT,
    start,
    end,
  }: { page?: number; size?: number; start?: string; end?: string } = {}
): Promise<LedgerWalletTransactionsResponse> => {
  return requestApi({
    url: `/earn/asset/${portfolioId}/transactions`,
    baseUrl: process.env.API_URL,
    method: 'GET',
    params: {
      walletReference: portfolioId,
      page,
      size,
      categories: 'EARNING',
      ...(start && { start }),
      ...(end && { end }),
    },
  })
}
